import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../../../../../../../CommonComponents/OPL/Input/Input';
import { MarginProps } from '../../../../../../../../theme/styledProps';

interface Props extends MarginProps {
  bucketIndex: number;
}

export const Name = ({ bucketIndex, ...rest }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Input
      {...register(`buckets.${bucketIndex}.title`)}
      label="Bucket Name"
      type="text"
      formVariant={errors?.buckets?.[bucketIndex]?.title?.message ? 'error' : undefined}
      helperText={errors?.buckets?.[bucketIndex]?.title?.message || 'Max. 40 characters'}
      maxLength={40}
      {...rest}
    />
  );
};
